<agpr-dialog-container
    [id]="id"
    heading="Briefings.emailDesign.previewEmail.dialog.header"
    [contentPadding]="true"
    (close)="close()"
>
    <agpr-twig
        [id]="id + '_twig'"
        [renderedHtml]="previewHtml"
    ></agpr-twig>

    <ng-template #footerRight>
        <agpr-button
            [id]="id + '_done'"
            label="Common.brandIdentity.manageDialog.button.done"
            (click)="close()"
            [style]="buttonTypesEnum.primary"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
